import { USER_ROLE } from '../enums/user';

const { ADMIN, USER } = USER_ROLE;

export default [
	{
		_name: 'CSidebarNavItem',
		name: 'Dashboard',
		icon: 'cil-monitor',
		to: '/dashboard',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'Stock browser',
		icon: 'cil-map',
		to: '/stock-browser',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'Order lists',
		icon: 'cil-clipboard',
		to: '/orders',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavDropdown',
		name: 'Allocation Rule',
		route: '/allocation-rule',
		icon: 'cil-view-quilt',
		items: [
			{
				name: 'Allocate to online stock',
				to: '/allocation-rule/online-stock',
				requireRoles: [ADMIN, USER],
			},
			{
				name: 'Allocate to channels',
				to: '/allocation-rule/channel',
				requireRoles: [ADMIN, USER],
			},
		],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'Online group management',
		icon: 'cil-flag-alt',
		to: '/online-group',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'Channel management',
		icon: 'cil-sitemap',
		to: '/channels',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'Users',
		icon: 'cil-user',
		to: '/users',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'Reports',
		icon: 'cil-bar-chart',
		to: '/reports',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'Errors',
		icon: 'cil-vertical-align-bottom',
		to: '/errors',
		requireRoles: [ADMIN, USER],
	},
	{
		_name: 'CSidebarNavItem',
		name: 'AuditLogs',
		icon: 'cil-notes',
		to: '/audit-logs',
		requireRoles: [ADMIN, USER],
	},
];
